import { CircularProgress, Grid, Icon, Pagination, Paper } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useJobmarketBillableCompaniesQuery } from 'api/hooks/jobmarket/invoices';
import { RichList, ErrorBoundary } from 'app/components';
import { NoItems } from 'app/components/RichList/components/NoItems';
import { InvoiceCompanyItem } from 'app/components/RichList/items/InvoiceCompanyItem';
import { translations } from 'locales/i18n';

import '../styles/InvoiceManagement.scss';

export function OpenOffers() {
  const { t } = useTranslation();
  const companyNameState = useState('');
  const [offset, setOffset] = useState(0);

  const { data: companiesData, isLoading } = useJobmarketBillableCompaniesQuery({
    params: { name: companyNameState[0], offset: offset, limit: 10 }
  });

  const handlePagination = (event, page: number) => {
    const offset = (page - 1) * 10;
    setOffset(offset);
  };

  if (isLoading) {
    return <CircularProgress />;
  }
  const companies = companiesData!;

  return (
    <ErrorBoundary boundaryTag="invoicesListBoundary">
      <RichList
        filters={[
          {
            field: 'name',
            label: t(translations.pages.manageCompanies.companyName()),
            stateHandler: companyNameState
          }
        ]}
        staticHeading={
          <Grid
            container
            className="invoice-management__list-heading"
            component={Paper}
            elevation={3}
            square
          >
            <Grid item md={1} className="invoice-management__list-heading__item">
              {t(translations.pages.invoices.companyId())}
            </Grid>
            <Grid item md={3} className="invoice-management__list-heading__item">
              {t(translations.common.companyName())}
            </Grid>
            <Grid item md={2} className="invoice-management__list-heading__item">
              {t(translations.pages.invoices.openOffers())}
            </Grid>
            <Grid item md={2} className="invoice-management__list-heading__item">
              {t(translations.pages.invoices.earliestPeriod())}
            </Grid>
            <Grid item md={2} className="invoice-management__list-heading__item">
              {t(translations.pages.invoices.openAmount())}
            </Grid>
            <Grid item md={2} className="invoice-management__list-heading__item">
              {t(translations.pages.invoices.actions())}
            </Grid>
          </Grid>
        }
      >
        {companies.data.length === 0 ? (
          <NoItems
            icon={<Icon className="fas fa-info-circle" />}
            message={t(translations.pages.invoices.noInvoicesToCreate())}
          />
        ) : (
          <>
            <Grid
              container
              component={Paper}
              elevation={1}
              square
              className="invoice-management__list"
            >
              {companies.data.map(c => (
                <ErrorBoundary key={c.id} boundaryTag="invoiceItemBoundary">
                  <InvoiceCompanyItem company={c} key={c.id} />
                </ErrorBoundary>
              ))}
            </Grid>
          </>
        )}
      </RichList>
      {Math.floor(companies.pagination?.count! / 10) > 0 && (
        <Grid container className="invoice-management__pagination">
          <Pagination
            count={Math.ceil(companies.pagination?.count! / 10)}
            onChange={handlePagination}
            variant="outlined"
            shape="rounded"
            showFirstButton
            showLastButton
            size="medium"
            color="primary"
            siblingCount={2}
            boundaryCount={2}
          />
        </Grid>
      )}
    </ErrorBoundary>
  );
}
